import { toast } from "react-toastify";

export const uploadLampiranFiles = async (suratId: number, files: FileList | null): Promise<boolean> => {
  if (!files || files.length === 0) return true;

  let hasError = false;
  let messageFile = "";

  for (const file of Array.from(files)) {
    if (file.size <= 0) continue;

    try {
      // console.log('Uploading file:', file.name, 'for surat_id:', suratId);

      // Create FormData for upload
      const formData = new FormData();
      formData.append('file', file);
      formData.append('surat_id', suratId.toString());
      formData.append('nama', file.name);
      formData.append('mime_type', file.type);

      // console.log('FormData entries:');
      // for (let pair of Array.from(formData.entries())) {
      //   console.log(pair[0], typeof pair[1] === 'object' ? `File: ${(pair[1] as File).name}` : pair[1]);
      // }

      // Upload via dedicated API endpoint
      const res = await fetch('/api/uploadLampiran', {
        method: 'POST',
        body: formData,
      });

      const text = await res.text();
      let result;
      try {
        result = JSON.parse(text);
      } catch (e) {
        console.error('Failed to parse response as JSON:', text.substring(0, 500));
        throw new Error(`Invalid server response: ${text.substring(0, 100)}...`);
      }

      // console.log('Upload response:', result);

      if (!res.ok || (result.http_code && ![200, 201].includes(result.http_code))) {
        console.error('Gagal mengupload dokumen:', file.name, result);

        // Tampilkan pesan error yang lebih detail
        const errorMsg = result.message || result.error || 'Unknown error';
        console.error('Error detail:', errorMsg);

        messageFile += `| ${file.name} (${errorMsg})`;
        hasError = true;
      } else {
        // console.log('File uploaded successfully:', file.name);
      }
    } catch (err) {
      console.error('Error upload lampiran:', err);
      messageFile += `| ${file.name} (${(err as Error).message})`;
      hasError = true;
    }
  }

  if (messageFile) {
    toast.error(`Gagal upload file: ${messageFile}`);
  }

  return !hasError;
};

export const uploadLampiranWithCustomId = async (
  suratId: number,
  files: FileList | File[] | null,
  customFields?: Record<string, string | number>
): Promise<boolean> => {
  if (!files || files.length === 0) return true;

  let hasError = false;
  let messageFile = "";

  const fileArray = files instanceof FileList ? Array.from(files) : files;

  for (const file of fileArray) {
    if (file.size <= 0) continue;

    try {
      // console.log('Uploading file:', file.name, 'with custom fields:', customFields);

      const formData = new FormData();
      formData.append('file', file);
      if (suratId > 0) formData.append('surat_id', suratId.toString());
      formData.append('nama', file.name);
      formData.append('mime_type', file.type);

      // Add custom fields if provided
      if (customFields) {
        Object.entries(customFields).forEach(([key, value]) => {
          formData.append(key, String(value));
        });
      }

      // console.log('FormData entries:');
      // for (let pair of Array.from(formData.entries())) {
      //   console.log(pair[0], typeof pair[1] === 'object' ? `File: ${(pair[1] as File).name}` : pair[1]);
      // }

      const res = await fetch('/api/uploadLampiran', {
        method: 'POST',
        body: formData,
      });

      const text = await res.text();
      let result;
      try {
        result = JSON.parse(text);
      } catch (e) {
        console.error('Failed to parse response as JSON:', text.substring(0, 500));
        throw new Error(`Invalid server response: ${text.substring(0, 100)}...`);
      }

      // console.log('Upload response:', result);

      if (!res.ok || (result.http_code && ![200, 201].includes(result.http_code))) {
        console.error('Gagal mengupload dokumen:', file.name, result);
        const errorMsg = result.message || result.error || 'Unknown error';
        messageFile += `| ${file.name} (${errorMsg})`;
        hasError = true;
      } else {
        // console.log('File uploaded successfully:', file.name);
      }
    } catch (err) {
      console.error('Error upload lampiran:', err);
      messageFile += `| ${file.name} (${(err as Error).message})`;
      hasError = true;
    }
  }

  if (messageFile) {
    toast.error(`Gagal upload file: ${messageFile}`);
  }

  return !hasError;
};
